import React from 'react'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'

import { Button } from '@/components/common'
import { APP_URL } from '@/config'

import styles from './NewsletterBackButton.module.scss'

export default function NewsletterBackButton() {
  const router = useRouter()
  const { formatMessage } = useIntl()

  const handleBack = () => {
    let isSameOrigin = false
    try {
      isSameOrigin = !!document.referrer &&
        new URL(document.referrer).origin === new URL(APP_URL).origin
    } catch (e) {
      // Falls through with isSameOrigin = false — fallback to /newsletter.
      // In local dev, APP_URL may be undefined if NEXT_PUBLIC_APP_URL_DEV is not set.
      if (process.env.NODE_ENV === 'development') {
        console.warn('NewsletterBackButton: referrer origin check failed', e)
      }
    }
    if (isSameOrigin) {
      router.back()
    } else {
      router.push('/newsletter')
    }
  }

  return (
    <Button
      aria-label={formatMessage({ id: 'pages.newsletter.archive.back' })}
      className={styles.wrapper}
      iconProps={{ name: 'chevron-left', position: 'left' }}
      onClick={handleBack}
      variant="link"
    >
      {formatMessage({ id: 'pages.newsletter.archive.back' })}
    </Button>
  )
}
